import { initialMenuModalState } from "./constants";
import { MenuInitialValues } from "./modals/AddEditMenuModal/AddEditMenuModal";
import { MenuInput, MenuStatusType, MenuTypeType } from "@me-team/host/main/graphql/types";
import { TFunction } from "i18next";
import * as Yup from "yup";
import { MenuModalState, PartialMenu } from "../../../interfaces/meMenuInterfaces/interfaces";

export const menuFormValidationSchema = (t: TFunction) =>
    Yup.object().shape({
        name: Yup.string().trim().required(t("validation.required")),
        type: Yup.string().oneOf(Object.values(MenuTypeType)).required(t("validation.required")),
    });

export const normalizeOnChange = (raw: string): string => raw.replace(/^\s+/, "").replace(/\s{2,}(?=\S)/g, " ");

export const normalizeOnBlur = (raw: string): string => {
    return raw.replace(/\s+/g, " ").trim();
};

export const createMenuModalHelpers = (setMenuModalState: (s: MenuModalState) => void) => ({
    openCreateMenuModal: () => setMenuModalState({ isOpen: true, mode: "create", menu: null }),
    openEditMenuModal: (menu: PartialMenu) => setMenuModalState({ isOpen: true, mode: "edit", menu: menu }),
    openCloneMenuModal: (menu: PartialMenu) => setMenuModalState({ isOpen: true, mode: "clone", menu: menu }),
    openRestoreMenuModal: (menu: PartialMenu) => setMenuModalState({ isOpen: true, mode: "restore", menu: menu }),
    closeMenuModal: () => setMenuModalState(initialMenuModalState),
});

export const makeMenuInput = (values: MenuInitialValues, overrides: Partial<MenuInput> = {}): MenuInput => ({
    name: values.name.trim(),
    type: values.type,
    languages: values.languages ?? [],
    status: values.status,
    ...overrides,
});

export const getDownloadableQrUrl = (url: string, basePath: string) => {
    const urlObj = new URL(url);
    return url.replace(urlObj.origin, basePath);
};

export const getStatusBannerInfo = (status?: MenuStatusType, t?: TFunction) => {
    switch (status) {
        case MenuStatusType.Activated:
            return {
                text: t("You are editing a published menu. All changes will be immediately visible to customers."),
                backgroundColor: "additional-orange",
                textColor: "orange",
                icon: "bi-exclamation-circle",
            };

        case MenuStatusType.Deactivated:
            return {
                text: t("This menu is not published. Customers cannot see it until you publish it."),
                backgroundColor: "additional-grey",
                textColor: "grey",
                icon: "bi-info-circle",
            };
        case MenuStatusType.UnderDevelopment:
            return {
                text: t("This menu is not published. Customers cannot see it until you publish it."),
                backgroundColor: "additional-grey",
                textColor: "grey",
                icon: "bi-info-circle",
            };

        default:
            return null;
    }
};
